import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Box, Container } from '@mui/material';
import { ProductListToolbar } from '../components/product/product-list-toolbar';
import { ProductListResults } from '../components/product/product-list-results';
import ProductService from '../services/product.service';
import { isNumber } from 'lodash';

const Products = () => {
  const productService =  new ProductService();
  const { user } = useSelector(state => state.user);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState(1);
  const [data, setData] = useState([]);


  const getProducts = async (p, l, s, f) => {
    try {
      productService.setAccessToken(user.accessToken);
      let response = '';
      if (s) {
        response = await productService.getProductsPerSearch(s);
      } else {
        response = await productService.getProducts();
      }
      setData(response.data);
      setProducts(response.data.data);
    } catch (error) {
      console.log(error)
    }
  };

  const changePage = (page) => {
    setPage(page);
  }
  const changeLimit = (limit) => {
    setLimit(limit);
  }


  const selectHandler = (e) => {
    if (e.target.value !== '' && isNumber(e.target.value)) {
      setFilter(e.target.value);
    }
  }

  const handleInput = (event) => {
    setSearch(event.target.value);
  }

  useEffect(()=>{
    // (async function getRecords() {
        getProducts(page, limit, search, filter);
    // })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search, filter])

  return(
    <>
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8
      }}
    >
      <Container maxWidth={false}>
        <ProductListToolbar
          onInput={handleInput}
        />
        <Box sx={{ mt: 3 }}>
          <ProductListResults
            products={products}
            changePage={changePage}
            changeLimit={changeLimit}
            count={data.records_total || 0}
          />
        </Box>
      </Container>
    </Box>
  </>
  )
};


export default Products;
